import { Component, OnInit } from '@angular/core';
import { ROUTE_CONSTANTS } from '@app/core/constants/route.constant';
import { CookieConsentService } from '@app/shared/services/cookie-consent.service';

@Component({
    selector: 'app-cookie-consent',
    templateUrl: './cookie-consent.component.html',
    styleUrl: './cookie-consent.component.scss',
    standalone: false,
})
export class CookieConsentComponent implements OnInit {
    readonly ROUTE_CONSTANTS = ROUTE_CONSTANTS;

    visible = false;
    // Optional cookies stay off until the visitor ticks them (no pre-ticked consent)
    analyticsChecked = false;
    marketingChecked = false;

    constructor(private readonly cookieConsentService: CookieConsentService) {}

    ngOnInit(): void {
        if (!this.cookieConsentService.hasConsent()) {
            setTimeout(() => (this.visible = true), 100);
        }
    }

    acceptAll(): void {
        this.cookieConsentService.setConsent({ analytics: true, marketing: true });
        this.hide();
    }

    savePreferences(): void {
        this.cookieConsentService.setConsent({
            analytics: this.analyticsChecked,
            marketing: this.marketingChecked,
        });
        this.hide();
    }

    rejectAll(): void {
        this.cookieConsentService.setConsent({ analytics: false, marketing: false });
        this.hide();
    }

    private hide(): void {
        this.visible = false;
    }
}
